/**
 * Base: Video element
 */


var ed = ed || {};

ed.video = new function(){
    /**
     * Init function
     */
    this.init = function() {
        playVideo();
    };

    function playVideo() {
        $('.video-element').on('click', function(){
            var videoId = $(this).data('video');

            if(videoId) {
                var videoIframeHtml = $('<iframe width="1200" height="674" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('src', 'https://player.vimeo.com/video/'+ videoId +'?autoplay=1&color=ffffff&title=0&byline=0&portrait=0');

                ed.overlay.create({
                    'content': videoIframeHtml,
                    'class': 'overlay--video'
                });

            }
        });
    }

};
